import { sendThirdPartySignUpEvent } from '@/integrations/trackingScripts/index';

import { envLocale } from '@/constant/env';
import { apiEndpoints } from '@/constant/urls';

const replaceStateInGoogleUrl = (
  originalUrl: string,
  newState: string
): string => {
  try {
    const url = new URL(originalUrl);
    const stateParam = url.searchParams.get('state');

    if (stateParam) {
      url.searchParams.set('state', newState);
      return url.toString();
    }

    return originalUrl;
  } catch (error) {
    console.error('Error parsing Google OAuth URL:', error);
    return originalUrl;
  }
};

export const handleHeroButtonLinkClick = async (
  e: React.MouseEvent<HTMLAnchorElement, MouseEvent>,
  href: string,
  target: '_self' | '_blank' = '_blank'
) => {
  e.preventDefault();
  const isGoogleButton = href.includes('https://accounts.google.com/o/oauth2');
  if (!isGoogleButton) {
    if (target === '_blank') {
      return window.open(href, '_blank');
    } else {
      return (window.location.href = href);
    }
  }
  const response = await fetch(
    `${apiEndpoints.oauthState}?origin=${
      envLocale === 'zh-cn' ? 'china' : 'global'
    }`,
    {
      method: 'GET',
    }
  );

  sendThirdPartySignUpEvent(href, document.referrer, 'google');

  const newState = await response.text();
  const updatedUrl = replaceStateInGoogleUrl(href, newState);
  window.open(updatedUrl, '_blank');
};
